import { Box, Grid, Stack, useElementBreakpoints } from "@compass/core";
import { BulkSelected, Select } from "components";
import { BulkSelectedItemErrors, Developer } from "generated/openApi";
import ApiService from "services/apiService";

export const SelectedDevelopers = (props: {
  developers: Map<number, Developer>;
  setDevelopers: (value: Map<number, Developer>) => void;
  errors: BulkSelectedItemErrors[];
  setErrors: (value: BulkSelectedItemErrors[]) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, mediumFieldBreakpoints } = useElementBreakpoints();

  const getItemLabel = (developer: Developer) => <Stack>{developer.name}</Stack>;

  return (
    <Box ref={breakpointsRef}>
      <BulkSelected
        label="Developer"
        items={props.developers || []}
        setItems={(value) => props.setDevelopers(value)}
        getItemLabel={getItemLabel}
        errors={props.errors}
        setErrors={props.setErrors}
        quickAdd={
          <Grid container spacing="sm">
            <Grid item xs={smallFieldBreakpoints}>
              <Select
                label={`Add Developer`}
                value={undefined as unknown as Developer}
                onChange={(e, value) => {
                  const newDevelopers = new Map(props.developers);
                  newDevelopers.set(value.id, value);
                  props.setDevelopers(newDevelopers);
                }}
                fetchFunction={(searchString) => ApiService.search.developers(searchString)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionDisabled={(option) => props.developers.has(option.id)}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {getItemLabel(option)}
                  </Box>
                )}
                getOptionLabel={() => ""}
              />
            </Grid>
          </Grid>
        }
      />
    </Box>
  );
};
